import { useAuth } from '../contexts/useAuth';
import { config } from '../config';

// Vide = même origine que le front, l'Ingress route /api vers l'API.
const API_URL = config.apiUrl;

interface ApiOptions {
    method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
    body?: unknown;
    params?: Record<string, unknown>;
}

async function fetchApi<T>(endpoint: string, options: ApiOptions = {}, token: string | null): Promise<T> {
    const { method = 'GET', body, params } = options;

    let url = `${API_URL}${endpoint}`;

    if (params) {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        if (queryString) {
            url += `?${queryString}`;
        }
    }

    const headers: HeadersInit = {
        'Content-Type': 'application/json',
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error?.message || 'API request failed');
    }

    return data;
}

export function useApi() {
    const { token } = useAuth();

    return {
        get: <T>(endpoint: string, params?: Record<string, unknown>) =>
            fetchApi<T>(endpoint, { method: 'GET', params }, token),

        post: <T>(endpoint: string, body?: unknown) =>
            fetchApi<T>(endpoint, { method: 'POST', body }, token),

        put: <T>(endpoint: string, body?: unknown) =>
            fetchApi<T>(endpoint, { method: 'PUT', body }, token),

        patch: <T>(endpoint: string, body?: unknown) =>
            fetchApi<T>(endpoint, { method: 'PATCH', body }, token),

        delete: <T>(endpoint: string) =>
            fetchApi<T>(endpoint, { method: 'DELETE' }, token),
    };
}
